<template>
    <section>
        <b-row class="grid-header" v-if="!hideAction">
            <b-col cols="12">
                <div class="pull-right mb-2">
                    <b-button variant="danger" size="sm" class="mr-2" @click="onReturnToVendor" :disabled="selectedDiscrepancy.length == 0 || isProcessing">
                        <i v-if="isReturningVendor" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
                        Return to Vendor
                    </b-button>
                    <b-button variant="primary" size="sm" class="mr-2" @click="onSendToStock" :disabled="selectedDiscrepancy.length == 0 || isProcessing">
                        <i v-if="isSendingToStock" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
                        Send to Stock
                    </b-button>
                    <b-button variant="success" size="sm" class="mr-2" @click="onAllocate" :disabled="selectedDiscrepancy.length == 0 || isProcessing" >
                        <i v-if="isAllocating" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
                        Allocate
                    </b-button>
                </div>
            </b-col>
        </b-row>
        <grid-component
            isResizable
            :gridId="inventoryDiscrepancyGridId"
            :itemData="itemData"
            :navigationField="'partNumber'"
            :dynamicValToLink="'-split-'"
            :onDynamicNav="showDetail"
            :fields="fields"
            @checkedItem="checkedRowItemIds=$event"
        />

        <b-modal id="split-details-modal-allocated" size="lg" ref="split-details-modal-allocated" hide-footer>
            <template slot="modal-header">
                <h5 class="modal-title">
                    {{ 'Inventory Split Details for Part ' + inventoryOnSplit.partNumber }}
                    <i v-show="isLoadingSplit" class="fa fa-spinner fa-pulse fa-fw"></i>
                </h5>
            </template>
            <inventory-split-component />
        </b-modal>
    </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import GridComponent from '@/shared/components/GridComponent';
import fields from '@/pages/Inventory/fields';
import InventorySplitComponent from '@/shared/components/InventorySplits';
import { GRID_ID } from '@/shared/constants';

export default {
    components: {
        GridComponent,
        InventorySplitComponent
    },
    props: {
        salesOrderLineId: {
            type: [Number, String],
            default: 0
        },
        hideAction: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fields,
            checkedRowItemIds: [],
            inventoryDiscrepancyGridId: GRID_ID.INVENTORY_SALES_ORDERS_DISCREPANCY_GRID,
            inventoryOnSplit: {},
            isLoadingSplit: false,
            isProcessing: false,
            isReturningVendor: false,
            isSendingToStock: false,
            isAllocating: false
        }
    },
    computed: {
        ...mapGetters('inventory', ['discrepanciesList']),
        itemData() {
            return this.discrepanciesList;
        },
        selectedDiscrepancy() {
            return this.discrepanciesList.filter(dis => this.checkedRowItemIds.includes(dis.id));
        }
    },
    methods: {
        ...mapActions('inventory', ['getDiscrepanciesBySalesOrderLineId', 'getInventorySplits', 'updateInventory', 'removeDiscrepancies', 'allocateInventory']),
        ...mapActions('vendorrmas', ['returnDiscrepancy']),
        ...mapMutations('inventory', {inventorySetItem: 'setItem'}),
        async getData() {
            if(this.salesOrderLineId){
                await this.getDiscrepanciesBySalesOrderLineId(this.salesOrderLineId);
            }
        },
        async showDetail(row) {
          try {
            this.isLoadingSplit = true;
            // this.setInventorySplitList([]);
            this.inventorySetItem({ resource:'inventorySplitList', payload: [] });
            this.inventoryOnSplit = row;
            this.$bvModal.show('split-details-modal-allocated');
            await this.getInventorySplits(row.inventoryId);
            this.isLoadingSplit = false;
          }catch (e) {
            this.isLoadingSplit = false;
          }
        },
        async onSendToStock() {
            let toSendStock = await this.openConfirmBox({
                message: 'Sending to stock will tag the item as a non-discrepancy. Are you sure you want to proceed?'
            });

            if (toSendStock) {
                this.isProcessing = true;
                this.isSendingToStock = true;
                await this.removeDiscrepancies({
                    salesOrderLineId: this.salesOrderLineId,
                    inventories: this.selectedDiscrepancy
                }).then((res) => {
                    this.isProcessing = false;
                    this.isSendingToStock = false;
                    if (res.status == 200) {
                        this.$snotify.success('Successfully sent to stock the selected inventory')
                    } else {
                        this.$snotify.info('There is an error sending to stock')
                    }                 

                    this.getData();
                });
                
                this.$emit('refreshAvailableParts');
                this.checkedRowItemIds = [];
            }
        },
        async onAllocate() {
            let toAllocate = await this.openConfirmBox({
                message: 'You are allocating a discrepancy item. Are you sure you want to proceed?'
            })
            
            if (toAllocate) {
                this.isProcessing = true;
                this.isAllocating = true;
                await this.allocateInventory({
                    salesOrderLineId: this.salesOrderLineId,
                    inventory: this.selectedDiscrepancy
                }).then((res) => {
                    this.isProcessing = false;
                    this.isAllocating = false;
                    if (res.length > 0) {
                        this.$snotify.success('Successfully allocated selected inventory')
                    } else {
                        this.$snotify.info('Cannot able to proceed.')
                    }

                    this.getData();
                });
                
                this.$emit('refreshAvailableParts');
                this.checkedRowItemIds = [];
            }
        },
        async onReturnToVendor() {
            let toReturnVendor = await this.openConfirmBox({
                message: 'This to create a vendor RMA to return to vendor. Are you sure you want to proceed?'
            })

            if (toReturnVendor) {
                this.isProcessing = true;
                this.isReturningVendor = true;
                await this.returnDiscrepancy({
                    salesOrderLineId: this.salesOrderLineId,
                    inventories: this.selectedDiscrepancy
                }).then((res) => {
                    this.isProcessing = false;
                    this.isReturningVendor = false;
                    for(let i = 0; i < res.length; i++) {
                        let routeData = this.$router.resolve({ name: 'vendorrmas.edit', params: {id: res[i] } })
                        window.open(routeData.href, '_blank');    
                    }

                    if (res.length > 0) {
                        this.$snotify.success('Successfully created vendor rma')
                    } else {
                        this.$snotify.info('Cannot able to proceed.')
                    }
                    
                    this.getData();
                })
            }

            this.$emit('refreshAvailableParts');
            this.checkedRowItemIds = [];
        }
    },
    watch: {
        salesOrderLineId() { this.getData(); }
    },
    mounted() {
        if (this.salesOrderLineId) { this.getData(); }
    }
}
</script>

<style>

</style>